<template>
    <section>
        <!-- 콘텐츠 시작 { -->
        <div class="ctWrap">
            <div class="spacer-50 pc-mode"></div>
            <div class="spacer-40 mb-mode"></div>
            <div class="login-top-box">
                <a href="" class="btn-logo"><img src="/img/common/logo.png"></a>
            </div>

            <div class="main-title">Login</div>
            <div class="spacer-30 pc-mode"></div>
            <div class="spacer-10 mb-mode"></div>
            <div class="login-middle-box">
                <p>E-Mail Address (Please type in the upper and lower case letters correctly)</p>
                <input type="text" name="loginEmail" id="loginEmail" class="form-control rpx-input-box" v-model="loginEmail" >
                <div class="spacer-20"></div>
                <p>Password (Please type in the upper and lower case letters correctly)</p>
                <input type="password" name="loginPassword" id="loginPassword" class="form-control rpx-input-box" v-model="loginPassword">
                <div class="spacer-20"></div>
                <div class="bottom-check">
                    <input id="checkbox1" type="checkbox" name="checkbox" value=""><label for="checkbox1">Remember ME</label>
                </div>

                <div class="spacer-20"></div>
                <div class="m-btn">
                    <a href="#" onclick="javascript:return false;" v-on:click="login">Login</a>
                </div>

                <div class="spacer-30"></div>
                <div class="f-pass">
                    <router-link to="/reset-pw" type="button">Forgot Your Password?</router-link>
                </div>
                <div class="spacer-10"></div>
                <div>
                    <p>If you cannot find your password, please contact us by e-mail(riri.xrp@gmail.com)</p>
                </div>
            </div>
            <!-- Modals -->
            <div class="row">
                <modal :show.sync="modals.notificationShow"
                       gradient="danger"
                       modal-classes="modal-danger modal-dialog-centered modal-title-notification">
                    <h6 slot="header" class="modal-title" id="modal-title-notification">Your attention is required</h6>

                    <div class="py-3 text-center">
                        <i class="ni ni-bell-55 ni-3x"></i>
                        <h4 class="heading mt-4">{{ notificationMessage }}</h4>
                    </div>

                    <template slot="footer">
                        <!--<base-button type="white">Ok, Got it</base-button>-->
                        <base-button type="link"
                                     text-color="white"
                                     class="ml-auto"
                                     @click="modals.notificationShow = false">
                            Close
                        </base-button>
                    </template>
                </modal>
            </div>
        </div> <!-- // #ctWrap 닫음 -->
    </section>
</template>
<style>

</style>

<script>
import axios from 'axios'
import Modal from "@/components/Modal.vue";
export default {
    components: {
        Modal
    },
    data: () =>{
        return {
            modals: {
                notificationShow: false,
            },
            notificationMessage : '',
            loginEmail: '',
            loginPassword: '',
        }
    },
    created() {
    },
    mounted() {
        $("#app").removeClass('main');
        $("#gnb").hide(); // 메인의 메인링크부분을 숨긴다.
    },
    methods:{
        login:function(){
            if (!this.loginEmail) {
                //alert("Please, Input Email-Address");
                //this.$bvModal.show('modal-title-default');
                this.notificationMessage = "Please, Input Email-Address";
                this.modals.notificationShow = true;
                return;
            }
            if (!this.loginPassword) {
                this.notificationMessage = "Please, Input Login-Password";
                this.modals.notificationShow = true;
                return;
            }
            this.$store
                .dispatch("login", {
                    email: this.loginEmail,
                    password: this.loginPassword,
                })
                .then(response => {
                    if (response.status == 200) {
                        this.$router.push('/');
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.notificationMessage = "Login Failed: The login-id or password are incorrect.";
                    this.modals.notificationShow = true;
                })
        }
    }
};
</script>
<style>
</style>
